import { useContext, useMemo } from "react";
import AuthContext from "../context/auth/AuthContext";
import {
  getNewTenantFeatures,
  getTenantRequirementsConfig,
  isTenantFeatureEnabled,
} from "../helper/tenantRequirements";

// Usage (tenant's own profile):
//   const { config, isEnabled, isNew } = useTenantRequirements();
//   if (isEnabled("aml")) { ... }
//   if (isNew("open_banking")) { ...show a "New" badge... }
// Reads `user.requirements_config` of the logged-in tenant; the default config
// when the tenant has none. `newFeatures` are the features a later config
// turned on that the tenant has not done yet (see getNewTenantFeatures).
const useTenantRequirements = () => {
  const { user } = useContext(AuthContext);
  const config = useMemo(() => getTenantRequirementsConfig(user), [user]);
  const isEnabled = (key) => isTenantFeatureEnabled(user, key);
  const newFeatures = useMemo(() => getNewTenantFeatures(user), [user]);
  const isNew = (key) => newFeatures.includes(key);
  return { config, isEnabled, newFeatures, isNew };
};

export default useTenantRequirements;
